import { OverlayRef } from '@angular/cdk/overlay';
import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { NotifyService } from 'src/app/Services/notify.service';
import { AppOverlayConfig, OverlayService } from 'src/app/Services/overlay.service';
import { ReportService } from 'src/app/Services/report.service';
import { SharedService } from 'src/app/Services/shared.service';

@Component({
  selector: 'ze-share-text-modal',
  templateUrl: './share-text-modal.component.html',
  styleUrls: ['./share-text-modal.component.scss']
})
export class ShareTextModalComponent implements OnInit {

  header: string = "Share Link";
  shareText: string = "";
  temporaryLink: string = "";
  linkType: boolean = false;  // False for 'login', true for 'temporary'
  hubIp: string = "";
  filename: string = "";

  @ViewChild('shareTextOverlayFormRef', { static: false }) private shareTextOverlayFormRef: TemplateRef<any>;
  private shareTextOverlayFormConfig: AppOverlayConfig;
  private overlayRef: OverlayRef;

  constructor(private vcRef: ViewContainerRef,
    private overlayService: OverlayService,
    private _sharedService: SharedService,
    private notifyservice: NotifyService,
    private reportService: ReportService) { }

  ngOnInit() {
    this.shareTextOverlayFormConfig = {
      hasBackdrop: true,
      backdropClass: 'overlay-backdrop-dark-class',
      positionStrategy: this.overlayService.positionGloballyCenter(),
      minWidth: '500px',
      width: '500px',
      maxHeight: '500px',
    };
    this.overlayRef = this.overlayService.createOverlay(this.shareTextOverlayFormConfig);

    this._sharedService.openOverlayshareTextEvent.subscribe(data => {
      this.shareText = "";
      this.header = "Share Link";
      this.temporaryLink = "";
      this.linkType = false;  // Default to 'login'
      this.hubIp = "";
      this.filename = "";

      if (data[0] && !this.overlayRef.hasAttached()) {
        this.shareText = data[1];
        if (data[2] !== undefined) {
          this.header = data[2];
        }
        if (data[3] !== undefined) {
          this.hubIp = data[3];
        }
        if (data[4] !== undefined) {
          this.filename = data[4];
        }
        this.overlayService.attachTemplatePortal(this.overlayRef, this.shareTextOverlayFormRef, this.vcRef);
      } else if (!data[0] && this.overlayRef.hasAttached()) {
        this.overlayRef.detach();
      }

      // Generate temporary link if linkType is true
      if (this.linkType) {
        this.generateTemporaryLink();
      }
    });
  }

  // Method to generate temporary link
  generateTemporaryLink() {
    if (this.linkType) {
      this.reportService.getPresignedVideoShareUrl(this.hubIp, this.filename).subscribe((url: string) => {
        this.temporaryLink = url;
      },
      (error) => {
        this.temporaryLink = "";
        this.notifyservice.notify("error", "Error", "Error in generating URL...");
      });
    }
  }

  onToggleChange(event: any) {
    this.linkType = event.checked; // Update linkType based on toggle state
    if (this.linkType) {
      this.generateTemporaryLink(); // Generate link if toggle is true
    }
  }

  cancel() {
    this._sharedService.openOverlayshareTextEvent.emit([false]);
  }

  copyToClipboard(text: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Ensure it's not visible
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '0';
    textArea.style.height = '0';
    textArea.style.opacity = '0';

    document.body.appendChild(textArea);

    textArea.select();
    document.execCommand('copy');

    document.body.removeChild(textArea);
    this.cancel();
  }

}
